import Glide from '@glidejs/glide'

(function($) {
  class HeThemeApplication {
    constructor () {
      const self = this;

      $('html').addClass('js-enabled');

      $(document).ready(function() {
        self.init();
      });
    }

    init () {
      this.screenWidth = $(document).width();
      this.screenHeight = $(window).height();
      this.scrollTop = $(window).scrollTop();

      this.initInSight();
      this.initSliders();
      this.initMenu();
      this.scroll();
      this.initFaq();

      function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return false;
      }

      function setNLCookie() {
        var date = new Date();
        date.setTime(date.getTime()+(1*24*60*60*1000));
        document.cookie = 'immowire_nl' + "=" + 'closed' + "; expires=" + date.toGMTString();
      }

      if (! getCookie('immowire_nl')) {
        $('.newsletter-popup').show();
      }

      $('.newsletter-popup__close').click(event => {
        event.preventDefault();

        $('.newsletter-popup').addClass('closed');
        setNLCookie();
      });

      $('.tnp-submit').click(event => {
        setNLCookie();
      });
    }

    scroll() {
      this.scrollTop = $(window).scrollTop();

      const inSightElements = $('.in-sight');

      if (this.scrollTop > 10) {
        $('.header__bar').addClass('header__bar--scrolled');
      }
      else {
        $('.header__bar').removeClass('header__bar--scrolled');
      }

      inSightElements.each((id, element) => {
        const $element = $(element);
        const offset = $element.height() < 200 ? $element.height() : 200;

        if ($element.offset().top < this.scrollTop + this.screenHeight - offset) {
          $element.addClass('is-in-sight');
        }
        else if ($element.offset().top >= this.scrollTop + this.screenHeight) {
          $element.removeClass('is-in-sight');
        }
      });
    }

    lateInit () {
      this.initRefs();
    }

    resize () {
      this.screenWidth = $(document).width();
      this.screenHeight = $(document).height();
    }

    initMenu() {
      const termButton = $('.category-switch__trigger');
      const termList = $('.category-switch__list');

      termButton.click(event => {
        event.preventDefault();

        termButton.toggleClass('active');
        termList.slideToggle();
      });


      this.initSubMenus();
      this.initMenuIndicator();
      this.initMobileMenu();

      $('.js-search').click(function(event) {
        event.preventDefault();
        $('#search').toggleClass('active');
      });
    }

    initInSight() {
      //$('.content > *').addClass('in-sight');
    }

    initRefs() {
      const refs = $('.testimon-list__item');

      if (! refs.length) {
        return;
      }

      refs.each((id, ref) => {
        ref = $(ref);
        const image = ref.find('.testimon-list__image');
        const imageWrapper = ref.find('.testimon-list__image-wrapper');
        const top = image.height() - 250;

        image.css({transition: 'top ' + top * .00667 + 's ease'});

        ref.mouseenter(() => {
          image.css({top: '-' + top + 'px'});
        }).mouseleave(() => {
          image.css({top: 0});
        });
      });
    }

    initSliders() {
      const sliders = document.querySelectorAll('.glide');

      if (! sliders.length) {
        return;
      }

      sliders.forEach((slider) => {
        if ($(slider).hasClass('header-slider')) {
          const headerGlide = new Glide(slider, {
            autoplay: 8000,
            hoverpause: false,
            type: 'slider'
          });

          headerGlide.on('mount.after', () => {
            $('#glide-text-0').addClass('header-slider__overlay-box--active');
          });

          headerGlide.mount();

          headerGlide.on('run.before', () => {
            $('.header-slider__overlay-box').removeClass('header-slider__overlay-box--active');
            const video = $('.header-slider__slide:nth-child(' + ( headerGlide.index + 1 ) + ')').find('video');
            if (video.length) {
              if (video[0].paused) {
                video[0].play();
              }
            }
          });

          headerGlide.on('run.after', () => {
            $(`#glide-text-${headerGlide.index}`).addClass('header-slider__overlay-box--active');
          });
        }
        else {
          const testimonialGlide = new Glide(slider, {
            autoplay: 10000,
            hoverpause: true,
            type: 'carousel'
          });

          testimonialGlide.mount();

          const detailButton = $('.testimonial-buttons__link--detail');

          testimonialGlide.on('run.after', () => {
            detailButton.attr('href', detailButton.data('link-' + testimonialGlide.index));
          });
        }
      });
    }

    initLoader() {
      $('a').click(function(event) {
        const target = $(this).attr('target');
        const href = $(this).attr('href');

        if (target == '_blank' || href.startsWith('tel') || href.startsWith('mailto') || href.startsWith('#') || href.startsWith('javascript')) {
          return true;
        }

        $('.loader').addClass('active');
      });
    }

    initMobileMenu() {
      if (window.matchMedia('(min-width: 1100px)').matches) {
        return;
      }

      $('.hamburger').click(function(event) {
        event.preventDefault();

        const hamburger = $(this);

        hamburger.toggleClass('hamburger--active');
        $('.menu-canvas').slideToggle();
      });

      $('.nav__sub-menu-inidcator').click(function(event) {
        event.preventDefault();

        $(this).toggleClass('nav__sub-menu-inidcator--active');
        $(this).next('.sub-menu').slideToggle();
      });
    }

    initSubMenus() {
      if (window.matchMedia('(max-width: 1099px)').matches) {
        return;
      }

      const menuItems = $('.nav__item--depth-0');
      const subMenus = $('.nav__sub-menu--depth-1');

      subMenus.each((id, menu) => {
        const parent = $(menu).parent();

        if (parent.width() >= $(menu).width()) {
          $(menu).width(parent.width());
        }

        $(menu).css({
          left: 'calc(50% + 10px)',
          marginLeft: -($(menu).width() / 2)
        });
      });

      menuItems.each((id, item) => {
        $(item).mouseenter(() => {
          clearTimeout(this.leaveLiTimeout);

          menuItems.removeClass('nav__item--hover');
          $(item).addClass('nav__item--hover');
        }).mouseleave(() => {
          this.leaveLiTimeout = setTimeout(() => {
            $(item).removeClass('nav__item--hover');
          }, 1000);
        });
      });
    }

    initFaq() {
      const triggers = $('.faq .wp-block-group__inner-container > h3');

      triggers.each((id, trigger) => {
        $(trigger).click(function(event) {
          event.preventDefault();

          $(this).toggleClass('active');
          $(this).next('.wp-block-group').slideToggle();
        });
      });
    }

    initMenuIndicator() {
      if (window.matchMedia('(max-width: 1099px)').matches) {
        return;
      }

      const menu = $('.nav');
      const menuElements = $('.nav__item--depth-0');
      const indicator = $('.menu-canvas__indicator');
      let activeElement = $('.nav__link--depth-0.nav__link--active');

      if (! activeElement.length) {
        activeElement = $('.nav__link--depth-0.nav__link--ancestor');
      }

      let indicatorCssOriginal = activeElement.length ? {
        left: activeElement.offset().left - menu.offset().left,
        width: activeElement.width()
      } : {
        left: 0,
        width: 0
      };

      const placeIndicator = activeElement => {
        const indicatorCss = {
          left: activeElement.offset().left - menu.offset().left,
          width: activeElement.width()
        };

        indicator.css(indicatorCss);
      };

      indicator.addClass('menu-canvas__indicator--active');

      if (activeElement.length) {
        placeIndicator(activeElement);
      }

      menuElements.each((id, element) => {
        const link = $(element).find('.nav__link');

        $(element).mouseenter(() => {
          placeIndicator(link);
        }).mouseleave(() => {
          if (indicatorCssOriginal.width == 0) {
            indicatorCssOriginal.left = link.offset().left - menu.offset().left;
          }

          indicator.css(indicatorCssOriginal);
        });
      });
    }
  }


  const heThemeApp = new HeThemeApplication();

  $(window)
    .on('load', function() {
      heThemeApp.lateInit();
    })
    .on('scroll', function() {
      heThemeApp.scroll();
    })
    .resize(function() {
      heThemeApp.resize();
    });

})(jQuery);